export default "__VITE_ASSET__BkvVbskn__"